export const TABLE_COLUMN_SIZING = {
  sm: 70,
  md: 100,
  lg: 140,
  xl: 180,
  xxl: 220,
  xxxl: 260,
};
